import React, { useState, useEffect ,createContext} from "react";
import { Layout, Menu, Avatar, Button,Dropdown } from "antd";
import { MenuOutlined, PoweroffOutlined } from "@ant-design/icons";
import ViewListIcon from "@mui/icons-material/ViewList";
import { useNavigate, Outlet } from "react-router-dom";
import MusicNoteIcon from "@mui/icons-material/MusicNote";
import FolderOpenIcon from "@mui/icons-material/FolderOpen";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import QueueMusicIcon from "@mui/icons-material/QueueMusic";
import PeopleIcon from "@mui/icons-material/People";
import HomeIcon from "@mui/icons-material/Home";
import Tooltip from "@mui/material/Tooltip";
import LoadingSpinner from "./loader";
import { DownOutlined } from "@ant-design/icons";

import "./dashboard.css";


export const LoaderContext = createContext();


const { Header, Sider, Content } = Layout;


const DashboardPage = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(true);
  const [selectedKey, setSelectedKey] = useState("1");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);

      if (mobile) {
        setSidebarCollapsed(true);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
const folderMenu = {
  items: [
    {
      key: "addbanner",
      label: "Add Banner",
      onClick: () => handleMenuClick("addbanner", "/dashboard/addbannerlist"),
    },
    {
      key: "addimg",
      label: "Add Image",
      onClick: () => handleMenuClick("addimg", "/dashboard/addimglist"),
    },
    {
      key: "addpdf",
      label: "Add PDF",
      onClick: () => handleMenuClick("addpdf", "/dashboard/addpdflist"),
    },
     {
      key: "homebanner",
      label: "Home Banner",
      onClick: () => handleMenuClick("homebanner", "/dashboard/homebannerlist"),
    },
     {
      key: "pdfcategory",
      label: "PDF Category",
      onClick: () => handleMenuClick("pdfcategory", "/dashboard/pdfcategorylist"),
    },
  ],
};

 const handleMenuClick = (key, path) => {
  setSelectedKey(key);
  if (path) navigate(path);
  if (isMobile) setSidebarCollapsed(true);
};


  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    navigate("/", { replace: true });
  };
 const handleMobileSidebarClose = () => {
 
  if (isMobile && !sidebarCollapsed) {
    setSidebarCollapsed(true);
  }
};
  return (
    <Layout style={{ minHeight: "100vh", padding: "10px" }}>
    
      <Header
      onClick={handleMobileSidebarClose}
        style={{
          background: "#fff",
          padding: "0 20px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
              width: "calc(100% - 20px)",
          height: "60px",
          position: "fixed",
          top: 10,
          left: 10,
          right: 10,
          zIndex: 100,
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          borderRadius: "12px",
        }}
      >
        {isMobile && (
          <Button
            type="text"
            icon={<MenuOutlined style={{ fontSize: "15px" }} />}
            onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
          />
        )}

        <div className="header-title">
          <MusicNoteIcon className="header-icon" />
         जिनभक्ती परिवार
        </div>

        <div style={{ marginLeft: "auto" }}>
          <Tooltip title="Logout" placement="bottom">
            <Avatar
              icon={
                <PoweroffOutlined style={{ fontSize: isMobile ? 18 : 25 }} />
              }
              style={{
                cursor: "pointer",
                backgroundColor: " #4B0082",
                width: isMobile ? 24 : 36,
                height: isMobile ? 24 : 36,
              }}
              onClick={handleLogout}
            />
          </Tooltip>
        </div>
      </Header>

      
      <Sider
        collapsible={isMobile}
        collapsed={sidebarCollapsed}
        onCollapse={(collapsed) => setSidebarCollapsed(collapsed)}
        breakpoint="md"
        collapsedWidth={isMobile ? 0 : 80}
        width={180}
        style={{
          background: "#fff",
          boxShadow: "5px 0 15px rgba(0,0,0,0.1)",
          position: "fixed",
          top: 80,
          bottom: 10,
          left: 10,
          zIndex: 90,
          borderRadius: "12px",
          overflow: "hidden",
        }}
      >
        <div className="logo-container">
          <img
            src={`${process.env.PUBLIC_URL}/images/logo1.png`}
            alt="Logo"
            style={{
              width: "130px",
              margin: "auto",
              display: "block",
              height: "150px",
            }}
          />
        </div>

        <Menu
          mode="inline"
          selectedKeys={[selectedKey]}
          style={{
            background: "transparent",
            border: "none",
            textAlign: "left",
            marginTop: "20px",
            width: "100%",
          }}
          items={[
            {
              key: "1",
              icon: <HomeIcon style={{ fontSize: "20px" }} />,
              label: "Home",
              path: "/dashboard/home",
            },
            {
              key: "2",
              icon: <PlaylistAddIcon style={{ fontSize: "20px" }} />,
              label: "Main Type",
              path: "/dashboard/maintypelist",
            },
            {
              key: "3",
              icon: <ViewListIcon style={{ fontSize: "20px" }} />,
              label: "Sub Type",
              path: "/dashboard/subtypelist",
            },
            {
              key: "4",
              icon: <FolderOpenIcon style={{ fontSize: "20px" }} />,
              label: "Category",
              path: "/dashboard/categorylist",
            },
            {
              key: "5",
              icon: <QueueMusicIcon style={{ fontSize: "20px" }} />,
              label: "Songs",
              path: "/dashboard/songmasterlist",
            },
            {
              key: "6",
              icon: <PeopleIcon style={{ fontSize: "20px" }} />,
              label: "User List",
              path: "/dashboard/userregistration-list",
            },
//          {
//   key: "7",
//   icon: <FolderOpenIcon style={{ fontSize: "20px" }} />,
//   label: (
//     <Dropdown
//       menu={folderMenu}
//       placement="rightTop"
//      trigger={["click"]}
//       getPopupContainer={() => document.body}
//     >
//       <div
//         onClick={() => setSelectedKey("7")}   
//         style={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           width: "100%",
//         }}
//       >
//         <span>Folder</span>
//       </div>
//     </Dropdown>
//   ),
// }


          ]}
          onClick={(e) => {
            const item = [
              { key: "1", path: "/dashboard/home" },
              { key: "2", path: "/dashboard/maintypelist" },
              { key: "3", path: "/dashboard/subtypelist" },
              { key: "4", path: "/dashboard/categorylist" },
              { key: "5", path: "/dashboard/songmasterlist" },
              { key: "6", path: "/dashboard/userregistration-list" },
            ].find((i) => i.key === e.key);
            if (item) handleMenuClick(e.key, item.path);
          }}
        />
      </Sider>

     
      <LoaderContext.Provider value={{ loading, setLoading }}>
      <Layout style={{ marginLeft: isMobile ? 5 : 190 }}>
        <Content
        onClick={handleMobileSidebarClose}
          className="content"
          style={{
             marginTop: "70px",
    marginRight: "10px",
    marginBottom: "10px",
    borderRadius: "12px",

    height: isMobile
      ? "calc(100dvh - 90px)"
      : "84vh",

    overflow: "hidden",
    boxShadow: "5px 0 15px rgba(0,0,0,0.1)",
    background: "#ffffff",

    display: "flex",
    flexDirection: "column",
          }}

        >
          {loading && <LoadingSpinner />}
          <div
            style={{
             flex: "1 1 auto",
    overflowY: "auto",
    WebkitOverflowScrolling: "touch",
    paddingRight: "5px",
            }}
            className="scroll-wrapper"
          >
            <Outlet />
          </div>
  <div className="dashboard-footer"style={{
    flexShrink: 0,}}>
  <div className="footer-divider"></div>

  <div className="footer-text">
    <span className="pink">COM</span>
    <span className="blue">TRANSE</span>
    <span className="black"> TECHNOLOGY PVT.LTD.KOLHAPUR</span>
  </div>
</div>



          <style>
            {`
              .scroll-wrapper::-webkit-scrollbar {
                width: 6px;
              }
              .scroll-wrapper::-webkit-scrollbar-track {
                background: transparent;
              }
              .scroll-wrapper::-webkit-scrollbar-thumb {
                background-color: #bab9b9;
                border-radius: 3px;
              }
              .scroll-wrapper::-webkit-scrollbar-thumb:hover {
                background-color: #9e9c9c;
              }
            `}
          </style>
        </Content>
      
      </Layout>
      </LoaderContext.Provider>
    </Layout>
  );
};

export default DashboardPage;
